import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, CardBody, Input, Button, Table, FormGroup, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import queryString from 'query-string';
import moment from "moment";
import { toast } from 'react-toastify';
import { isEmpty } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import { connect } from 'react-redux';
import Flatpickr from 'react-flatpickr';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import { baseUrl } from '../../constants/environment';
import IconSearch from '../../assets/images/icon-search.png';
import IconEdit from '../../assets/images/icon-edit.png';
import IconCalendarBlack from '../../assets/images/icon/ic_calendar-black.svg';
import PriceUtils from '../../helpers/PriceUtils';

const configPage = {
    titlePage: 'Quản lý danh sách nhà cung cấp',
    pathPage: '/supplier',
    column: 7,
}

interface Props {
    history: any,
    location: any,
    user: any,
}
const initialParams = {
    page: 1,
    limit: 25,
    filter: {
        page: 1,
        limit: 25,
        // name:"",
        // sex:"",
    }
}

export const StatusList = [
    {
        value: "",
        label: "-Trạng thái-"
    },
    {
        value: 1,
        label: "Đang hoạt động"
    },
    {
        value: 0,
        label: "Ngừng hoạt động"
    },
]


const List: React.FC<Props> = (props: Props) => {
    const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState({});
    const [nganh_hangs, setNganh_hangs] = useState<any>();
    const [dataCount, setDataCount] = useState<any>();
    const [ids, setIds] = useState([]);
    const searchPrams = queryString.parse(props.location.search)

    const setPage = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            page: value
        }));
    }

    const setLimit = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            limit: value
        }));
    }

    const setFilter = (value: {}) => {
        setParams((prevState: any) => ({
            ...prevState,
            filter: value
        }));
    }

    useEffect(() => {
        document.title = configPage.titlePage
    }, []);

    useEffect(() => {
        loadData()
        setFilterParams({
            page:page,
            limit: limit,
            ...filter,
        });
    }, [filter]);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const getFilterParams = () => {
        const newFilter: any = {}
        if (!isEmpty(searchPrams)) {
            Object.keys(searchPrams).map(function (key) {
                switch (key) {
                    case 'page':
                        setPage(Number(searchPrams[key]))
                        break;
                    case 'limit':
                        setLimit(Number(searchPrams[key]))
                        break;
                    default:
                        newFilter[key] = searchPrams[key]
                        break;
                }
            });
            setFilter(newFilter)
        }
    }

    const setFilterParams = (params: any) => {
        var filterParams = ''
        Object.keys(params).map(function (item, i) {
            if (i === 0) {
                if (params[item]) filterParams = filterParams + '?' + item + '=' + params[item]
            } else {
                if (params[item]) filterParams = filterParams + '&' + item + '=' + params[item]

            }
        });
        props.history.push({
            search: filterParams
        })
    }

    const loadData = async () => {
        setLoading(true);
        const formData = {
            page: filter?.page,
            limit: filter?.page,
            ...filter,
        }
        if(formData?.name === "") {
            delete formData?.name
        }
        if(formData?.status === "") {
            delete formData?.status
        }
        if(formData?.from && formData?.to) {
            formData.from = moment(formData?.from).startOf('day').valueOf()
            formData.to = moment(formData?.to).endOf('day').valueOf()
        }
        const url = `${baseUrl}/supplier`;
        let response: any = await APIClient.GET(url, formData);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error)
        } else if (response.response?.data !== undefined) {
            setData(response.response?.data)
            setTotalElements(response.response?.total)
        }
    }

    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: configPage.titlePage, active: true },
                ]}
                title={configPage.titlePage}
            />
            <PageBody>
                <DataFilter
                    filter={filter}
                    configPage={configPage}
                    setFilter={(filter: any) => setFilter(filter)}
                />
                <DataTableList
                    user={props?.user}
                    data={data} loading={loading}
                    page={page} limit={limit}
                    configPage={configPage}
                    history={props.history}
                    handleActionModal={(data: any) => handleActionModal(data)}
                />
                {
                    data?.length > 0 &&
                    <Pagination
                        link={configPage.pathPage + '/list'}
                        setPage={(page: number) => setFilter({...filter, page:page})}
                        page={filter?.page}
                        limit={filter?.limit}
                        setLimit={(limit: number) => setFilter({...filter, limit:limit})}
                        type={'noresetpage'}
                        totalElements={totalElements}
                    />
                }
                
            </PageBody>
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                <RenderActionModal closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()}/>
            </ModalPopup>
        </React.Fragment>
    );
};

const DataTableList = (props: any) => {
    const { data, filter, loading, limit, page, is_draft, configPage, handleActionModal} = props
    const start = limit * (page - 1)
    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th style={{ minWidth: 120 }}>Mã nhà cung cấp</th>
                    <th style={{ minWidth: 120 }}>Tên nhà cung cấp</th>
                    <th style={{ minWidth: 120 }}>Nhóm nhà cung cấp</th>
                    <th style={{ minWidth: 120 }}>Số điện thoại</th>
                    <th style={{ minWidth: 120 }}>Dư có</th>
                    <th style={{ minWidth: 120 }}>Dư nợ</th>
                    <th style={{ minWidth: 120 }}>Trạng thái</th>
                    <th style={{ minWidth: 120 }}>Ngày tạo</th>
                    <th style={{ width: 170 }} >Thao tác</th>
                </tr>
            </thead>
        )
    }
    const RenderBobyData = () => {
        const router = useHistory()
        if (loading) {
            return <RowLoading column={configPage.column} row={data.length || limit} />
        }
        if (data.length === 0) {
            return <RowEmpty column={configPage.column} title="Chưa có nhà cung cấp nào!" />;
        }

        const gotoDetail = (item:any) => {
            router?.push(`/supplier/${item?.id}/view`)
        }

        return (
            <tbody>
                {data && data.map((item: any, index: number) => {
                    const total_debt = Number(item?.total_debt || 0)
                    return (
                        <tr key={index}>
                            <td onClick={() => gotoDetail(item)}>{item?.code}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.name}</td>
                            <td onClick={() => gotoDetail(item)}>---</td>
                            <td onClick={() => gotoDetail(item)}>{item?.phone}</td>
                            <td onClick={() => gotoDetail(item)}>{total_debt > 0 ? PriceUtils.format(Number(total_debt), ''): 0}</td>
                            <td onClick={() => gotoDetail(item)}>{total_debt < 0 ? PriceUtils.format(Number(total_debt), ''): 0}</td>
                            <td onClick={() => gotoDetail(item)}>
                                <span className={item?.status == 1 ? 'text-success' : 'text-danger'}>{item?.status == 1 ? "Đang hoạt động" : "Ngừng hoạt động" }</span>
                            </td>
                            <td onClick={() => gotoDetail(item)}>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                            <td>
                                <div className="table-action">
                                    <div className="button-nutri" onClick={() => router?.push(`/supplier/${item?.id}`)}><img width={20} height={20} src={IconEdit} alt="edit" /></div>
                                    <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'stop', data: item})}><i className='uil-trash-alt'></i></div>
                                </div>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        )
    }

    return (
        <div>
            {/* <h4 className="header-title mt-0 mb-3">Danh sách {configPage.titlePage}</h4> */}
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
            {/* {loading && <Loader />} */}
        </div>
    );
};

const DataFilter = (props: any) => {
    const { setFilter, filter, setPage} = props
    const [name, setName] = useState(filter?.name);
    const timer = useRef<any>(null);

    const handleChangeFilterDate = (date:any) => {
        if(date.length === 2){
            const from = moment(date[0]).startOf("day").format('YYYY-MM-DD')
            const to = moment(date[1]).endOf("day").format('YYYY-MM-DD')
            setFilter({
                ...filter,
                from:from,
                to:to
            })
        }else if(date.length === 0){
            setFilter({
                ...filter,
                from:undefined,
                to:undefined
            })
        }   
    }

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            clearTimeout(timer.current)
            setFilter({
                ...filter,
                page: 1,
                name: e.target.value,
            })
        }
    }

    const handleChange = (e: any) => {
        clearTimeout(timer.current)
        const { name, value } = e?.target
        if(name == 'provinces_code') {
            setFilter({
                ...filter,
                page: 1,
                district_code: '',
                wards_code: '',
                [name]: value
            })
        }
        else if(name == 'district_code') {
            setFilter({
                ...filter,
                page: 1,
                wards_code: '',
                [name]: value
            })
        }
        else {
            setFilter({
                ...filter,
                page: 1,
                [name]: value
            })
        }
    }

    return (
        <Row className="mb-3 filter-custom">
            <Col xl={10}>
                <Row>
                    <Col xl={4}>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                                <img src={IconSearch} width={18} height={18} alt=""/>
                            </InputGroupAddon>
                            <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Tên hoặc mã nhà cung cấp" />
                        </InputGroup>
                    </Col>
                    <Col xl={8}>
                        <Row>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Trạng Thái-"
                                    options={StatusList}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'status', value: value.value } })
                                    }}
                                    value={StatusList?.filter((option: any) => filter?.status === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={5}>
                                <InputGroup className='form-control picker-custom'>
                                    <Flatpickr 
                                        value={[new Date(moment(filter?.from,'YYYY-MM-DD').startOf('day').valueOf()), new Date(moment(filter?.to,'YYYY-MM-DD').startOf('day').valueOf())]}
                                        onChange={(date:any) => { handleChangeFilterDate(date) }} 
                                        options={{
                                            mode: "range",
                                            locale: Vietnamese,
                                            dateFormat: "d/m/Y",
                                        }}
                                        className="flatpickr-input active"
                                        placeholder="Ngày tạo"
                                    />
                                    <div className="icon-clear" style={{right:23}} onClick={()=>{setFilter({...filter, from: null, to:null})}}>
                                        <i className="uil-times mr-1"></i>
                                    </div>
                                    <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                            <img src={IconCalendarBlack} alt="icon" />
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xl={2}>
                <div className="text-right">
                    <Link to={`${configPage.pathPage}/add`}><Button color="success" className="ml-2"><i className='uil uil-plus mr-1'></i>Thêm mới</Button></Link>
                </div>
            </Col>
        </Row>
    );
};

const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const { closeModal, action, loadData } = props
    const router=useHistory()
    
    const handleDelete = async() => {
        setLoading(true)
        const url = `${baseUrl}/supplier/${action?.data?.id}`;
        let response: any = await APIClient.DELETE(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xóa nhà cung cấp thành công!')
            closeModal()
            loadData()
        }
    }

    const handleStop = async() => {
        setLoading(true)
        const url = `${baseUrl}/branch/${action?.data?.id}`;
        const params = {
            status: 0,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Ngừng hoạt động cơ sở khám/ tư vấn thành công')
            closeModal();
            loadData()
        }
    }

    return (
        <CardBody className='p-0' style={{width:400}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    Thông báo
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="p-3 pt-4 text-center">Bạn có chắc chắn muốn xóa nhà cung cấp <br /> <b className='text-danger'>{action?.data?.name}</b></div>
            <div className="modal-body pt-2 pb-2">
                <Col md={12}>
                    <FormGroup row className="label-only">
                        {action?.type === 'delete' ?
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn xoá yêu cầu này?<br/> Hành động này không thể hoàn tác</p>
                            :action?.type === 'delete_list' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>{`Bạn có chắc chắn xoá ${action?.data?.length} yêu cầu này?`}<br/> Hành động này không thể hoàn tác</p>
                        }
                    </FormGroup>
                </Col>
            </div>
            <div className="modal-footer">
                <Button
                    onClick={closeModal}
                    className="ml-2 success-bland" color="success" type="button"
                > Hủy bỏ</Button>
                <Button
                    onClick={handleDelete}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>
            {loading && <Loader />}
        </CardBody>

    )
}

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(List)